import { CategoryTypes } from "../interfaces/enums";

/**
 * Zwraca polską etykietę dla typu kategorii
 */
export const getCategoryTypeLabel = (type: CategoryTypes): string => {
  switch (type) {
    case CategoryTypes.SOLO:
      return "Solo";
    case CategoryTypes.DUO:
      return "Duet";
    case CategoryTypes.TRIO:
      return "Trio";
    case CategoryTypes.OTHER:
      return "Inne";
    default:
      return String(type);
  }
};
